<template>
  <div class="select-button">
    <div class="select-button__select">
      <slot name="select"></slot>
    </div>

    <div class="select-button__button">
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'l-select-button'
};
</script>

<style lang="scss">
.select-button {
  display: inline-flex;
  align-items: stretch;
  width: 100%;

  .select-button__select {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
  }

  .select-button__button {
    flex: 0 0 auto;
    margin-left: -1px;
    display: inline-flex;
    align-items: stretch;
  }

  .select-button__select .el-select,
  .select-button__select .el-input {
    width: 100%;
  }

  .select-button__select .el-input__inner,
  .select-button__select .el-input.is-focus .el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-radius: 0 !important;
  }

  .select-button__button .el-button {
    height: 100%;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-radius: 0 !important;
  }

  .select-button__button .el-button + .el-button {
    margin-left: 0;
  }

  .select-button__button .el-button:focus,
  .select-button__button .el-button:hover,
  .select-button__button .el-button:active {
    position: relative;
    z-index: 1;
  }
}
</style>
